<template>
  <div class="blok-date" v-editable="blok" :style="{fontSize: fontSize}">
    <span v-if="blok.labeled">{{ blok.label }}</span>
    <span>{{ convertedDate }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'blok-date',
  props: ['blok', 'publishedAt'],
  computed: {
    convertedDate() {
      return moment(this.publishedAt).format('ll')
    },
    fontSize() {
      return this.blok.size || 14
    },
  },
}
</script>

<style scoped>
.blok-date {
  font-style: italic;
  display: inline-block;
  padding: 5px;
}
</style>
